/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  RemoveTradingChallengeUsersOptions,
  RemoveTradingChallengeUsersStatus200,
  RemoveTradingChallengeUsersStatus400,
  RemoveTradingChallengeUsersStatus403,
  RemoveTradingChallengeUsersStatus409,
  RemoveTradingChallengeUsersStatus500,
} from '../types/RemoveTradingChallengeUsers'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { removeTradingChallengeUsers } from '../clients/removeTradingChallengeUsers'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const removeTradingChallengeUsersMutationKey = () =>
  [{ url: '/v1/trading_challenges/remove_users' }] as const

export function removeTradingChallengeUsersMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = removeTradingChallengeUsersMutationKey()
  return mutationOptions<
    RemoveTradingChallengeUsersStatus200,
    ResponseErrorConfig<
      | RemoveTradingChallengeUsersStatus400
      | RemoveTradingChallengeUsersStatus403
      | RemoveTradingChallengeUsersStatus409
      | RemoveTradingChallengeUsersStatus500
    >,
    RemoveTradingChallengeUsersOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ body }) => {
      return removeTradingChallengeUsers({ ...config, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @description Remove users from a trading challenge. For COMPETITION_MANAGER, the challenge must be assigned in managed_competition_ids.
 * @summary Remove users from a trading challenge
 * {@link /v1/trading_challenges/remove_users}
 */
export function useRemoveTradingChallengeUsers<TContext>(
  options: {
    mutation?: UseMutationOptions<
      RemoveTradingChallengeUsersStatus200,
      ResponseErrorConfig<
        | RemoveTradingChallengeUsersStatus400
        | RemoveTradingChallengeUsersStatus403
        | RemoveTradingChallengeUsersStatus409
        | RemoveTradingChallengeUsersStatus500
      >,
      RemoveTradingChallengeUsersOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? removeTradingChallengeUsersMutationKey()

  const baseOptions = removeTradingChallengeUsersMutationOptions(config) as UseMutationOptions<
    RemoveTradingChallengeUsersStatus200,
    ResponseErrorConfig<
      | RemoveTradingChallengeUsersStatus400
      | RemoveTradingChallengeUsersStatus403
      | RemoveTradingChallengeUsersStatus409
      | RemoveTradingChallengeUsersStatus500
    >,
    RemoveTradingChallengeUsersOptions,
    TContext
  >

  return useMutation<
    RemoveTradingChallengeUsersStatus200,
    ResponseErrorConfig<
      | RemoveTradingChallengeUsersStatus400
      | RemoveTradingChallengeUsersStatus403
      | RemoveTradingChallengeUsersStatus409
      | RemoveTradingChallengeUsersStatus500
    >,
    RemoveTradingChallengeUsersOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    RemoveTradingChallengeUsersStatus200,
    ResponseErrorConfig<
      | RemoveTradingChallengeUsersStatus400
      | RemoveTradingChallengeUsersStatus403
      | RemoveTradingChallengeUsersStatus409
      | RemoveTradingChallengeUsersStatus500
    >,
    RemoveTradingChallengeUsersOptions,
    TContext
  >
}
